import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

/**
 * Admin Route - Protects admin routes and checks for admin privileges
 */
const AdminRoute = ({ children }) => {
  const { user } = useContext(AuthContext);

  // Check if user is logged in
  if (!user) {
    return <Navigate to="/login" />;
  }

  // Admin check logic - HARDCODED ADMIN EMAIL
  const isAdmin = () => {
    // HARDCODED ADMIN EMAIL - CHANGE THIS TO YOUR SPECIFIC EMAIL
    const ADMIN_EMAIL = "rekhithasree@gmail.com";  // <<<< CHANGE THIS TO YOUR EMAIL

    // Debug: Log user object to see what we have
    console.log('DEBUG - User object:', user);
    console.log('DEBUG - User email:', user.email);
    console.log('DEBUG - Expected admin email:', ADMIN_EMAIL);

    // Option 1: Check if user is superuser (if you have this info from token)
    if (user.is_superuser) {
      console.log('DEBUG - User is superuser');
      return true;
    }

    // Option 2: HARDCODED admin email check
    if (user.email && user.email.toLowerCase() === ADMIN_EMAIL.toLowerCase()) {
      console.log('DEBUG - Email matches admin email');
      return true;
    }

    // Option 3: Additional admin emails (add more if needed)
    const additionalAdminEmails = [
      'admin@vasstr.com',
      'admin@fitcraft.com'
    ];

    const emailMatch = user.email && additionalAdminEmails.includes(user.email.toLowerCase());
    console.log('DEBUG - Additional email match:', emailMatch);

    return emailMatch;
  };

  if (!isAdmin()) {
    // Show detailed error with debug info
    return (
      <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'Arial, sans-serif' }}>
        <h2>🚫 Access Denied</h2>
        <p>Admin access required for this page.</p>
        <div style={{ margin: '20px 0', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
          <h3>Debug Information:</h3>
          <p><strong>Your Email:</strong> {user.email || 'Not found in token'}</p>
          <p><strong>Expected Admin Email:</strong> rekhithasree@gmail.com</p>
          <p><strong>Is Superuser:</strong> {user.is_superuser ? 'Yes' : 'No'}</p>
          <p><strong>Full User Object:</strong></p>
          <pre style={{ textAlign: 'left', fontSize: '12px' }}>
            {JSON.stringify(user, null, 2)}
          </pre>
        </div>
        <button
          onClick={() => window.location.href = '/homepage'}
          style={{ padding: '10px 20px', fontSize: '16px', backgroundColor: '#2C1810', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
        >
          Return to Homepage
        </button>
      </div>
    );
  }

  return children;
};

export default AdminRoute;